import React from "react";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";
import { resolveHomeIcon } from "./HomeIcons";

function renderShowcaseSurface(panel, index) {
  if (index === 0) {
    return (
      <div className="public-home-premium__showcase-surface public-home-premium__showcase-surface--workspace" aria-hidden="true">
        <div className="public-home-premium__showcase-profile-row">
          <div className="public-home-premium__showcase-avatar" />
          <div className="flex flex-col gap-1">
            <strong>Candidate Workspace</strong>
            <p>Beruf, Readiness, Nachweise und Integrationssignale greifen zusammen.</p>
          </div>
          <span className="public-home-premium__surface-status">Live</span>
        </div>
        <div className="public-home-premium__showcase-profile-meta">
          <span>Kontextlayer verbunden</span>
          <span>Review aktiv</span>
        </div>
        <div className="public-home-premium__showcase-chip-row">
          {(panel.details || []).map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <div className="public-home-premium__showcase-data-grid">
          <article>
            <span>Readiness</span>
            <strong>72%</strong>
          </article>
          <article>
            <span>Dokumente</span>
            <strong>8 / 11</strong>
          </article>
          <article>
            <span>Sprache</span>
            <strong>B1 Pfad</strong>
          </article>
        </div>
        <div className="public-home-premium__showcase-context-grid">
          <article>
            <span>Kontextgrad</span>
            <strong>hoch</strong>
            <p>Beruf, Nachweise und Fortschritt sind verbunden.</p>
          </article>
          <article>
            <span>Nächste Prüfung</span>
            <strong>Lizenz</strong>
            <p>Die offene Evidenz ist bereits in der Prozessspur markiert.</p>
          </article>
        </div>
      </div>
    );
  }

  if (index === 1) {
    return (
      <div className="public-home-premium__showcase-surface public-home-premium__showcase-surface--verification" aria-hidden="true">
        {[
          { label: "Pass / Identität", state: "Geprüft", tone: "good" },
          { label: "Qualifikationsnachweis", state: "Lesbar", tone: "good" },
          { label: "Lizenz / Berufsanerkennung", state: "Im Review", tone: "pending" },
        ].map((item) => (
          <div key={item.label} className="public-home-premium__showcase-verification-row">
            <span>{item.label}</span>
            <div className="public-home-premium__showcase-verification-status">
              <em>{item.state}</em>
              <i className={item.tone === "pending" ? "is-pending" : "is-good"} />
            </div>
          </div>
        ))}
        <div className="public-home-premium__showcase-callout">
          <span>Nachforderung</span>
          <strong>Lizenznachweis im Review</strong>
        </div>
      </div>
    );
  }

  if (index === 2) {
    return (
      <div className="public-home-premium__showcase-surface public-home-premium__showcase-surface--readiness" aria-hidden="true">
        {[
          { label: "Sprache", value: 68 },
          { label: "Berufsnähe", value: 84 },
          { label: "Vorbereitung", value: 61 },
        ].map((item) => (
          <div key={item.label} className="public-home-premium__showcase-meter">
            <div className="flex items-center justify-between gap-3">
              <span>{item.label}</span>
              <strong>{item.value}%</strong>
            </div>
            <div className="public-home-premium__showcase-meter-track">
              <i style={{ width: `${item.value}%` }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (index === 3) {
    return (
      <div className="public-home-premium__showcase-surface public-home-premium__showcase-surface--employer" aria-hidden="true">
        <div className="public-home-premium__showcase-context-grid public-home-premium__showcase-context-grid--compact">
          <article>
            <span>Fit-Signal</span>
            <strong>86%</strong>
            <p>Belastbarer Kontext statt Profilfragment.</p>
          </article>
          <article>
            <span>Pflichten</span>
            <strong>sichtbar</strong>
            <p>Welcome- und Wohnraumlogik eingeblendet.</p>
          </article>
        </div>
        <div className="public-home-premium__showcase-chip-row">
          {["Fit-Signal", "Pflichten", "Welcome"].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <ul className="public-home-premium__showcase-list">
          <li>Wohnraumunterstützung bestätigt</li>
          <li>Welcome-Prämie eingeblendet</li>
          <li>Onboarding-Slot reserviert</li>
        </ul>
      </div>
    );
  }

  return (
    <div className="public-home-premium__showcase-surface public-home-premium__showcase-surface--filing" aria-hidden="true">
      <div className="public-home-premium__showcase-timeline">
        {[
          { label: "Filing-Pack", state: "aktiv" },
          { label: "Behördenpfad", state: "nächster Schritt" },
          { label: "Arrival-Plan", state: "sichtbar" },
        ].map((item) => (
          <div key={item.label} className="public-home-premium__showcase-timeline-item">
            <i />
            <div className="public-home-premium__showcase-timeline-copy">
              <span>{item.label}</span>
              <em>{item.state}</em>
            </div>
          </div>
        ))}
      </div>
      <div className="public-home-premium__showcase-callout">
        <span>Transfer</span>
        <strong>Übergabe bleibt nachvollziehbar</strong>
      </div>
    </div>
  );
}

export default function HomeSystemShowcase({ content }) {
  return (
    <section className="public-home-premium__section public-home-premium__section--product" id="showcase">
      <div className="mx-auto flex w-full max-w-page flex-col gap-10 px-4 sm:px-6 lg:px-8">
        <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} lead={content.lead} />

        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-12">
          {(content.panels || []).map((panel, index) => {
            const Icon = resolveHomeIcon(panel.icon);
            const cardClassName =
              index === 0
                ? "xl:col-span-7"
                : index === 1
                  ? "xl:col-span-5"
                  : "xl:col-span-4";

            return (
              <MotionReveal key={panel.title} className={cardClassName} delay={0.04 + index * 0.04}>
                <article className={`public-home-premium__showcase-card public-home-premium__showcase-card--${index}`.trim()}>
                  <div className="flex items-center justify-between gap-4">
                    <span className="public-home-premium__icon-chip">
                      <Icon size={18} strokeWidth={1.8} />
                    </span>
                    <span className="public-home-premium__mini-label">{panel.eyebrow}</span>
                  </div>

                  <div className="flex flex-col gap-3">
                    <h3>{panel.title}</h3>
                    <p>{panel.text}</p>
                  </div>

                  {renderShowcaseSurface(panel, index)}
                </article>
              </MotionReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
